import 'babel-polyfill'
import 'url-search-params-polyfill'
import 'intersection-observer'

import Closest from './globals/js/pollyfills/closest'
import TabHighlight from './globals/js/helpers/tabHighlight'
import EpiTracking from './globals/js/tracking/epiTracking'

import Search from './components/Search/Search'
import TextExpander from './components/TextExpander/TextExpander'
import LazyImage from './components/LazyImage/LazyImage'
import TitleCard from './components/TitleCard/TitleCard'
import NavMain from './components/NavMain/NavMain'
import LenderDetail from './components/LenderDetail/LenderDetail'
import LenderList from './components/lender_list/LenderList'
import LenderFilterGranular from './components/LenderFilterGranular/LenderFilterGranular'
import TableOfContents from './components/TableOfContents/TableOfContents'
import TableOfContentsEnhanced from './components/TableOfContentsEnhanced/TableOfContentsEnhanced'
import BlockFAQ from './blocks/BlockFAQ/BlockFAQ'
import BlockNewsletter from './blocks/BlockNewsletter/BlockNewsletter'
import BlockContact from './blocks/BlockContact/BlockContact'
import SingleLGLender from './pages/single-lg_lender/SingleLGLender'
import AlphabetNav from './components/AlphabetNav/AlphabetNav'

const components = [
  Closest(),
  TabHighlight(),
  EpiTracking(),
  Search(),
  TitleCard(),
  NavMain(),
  LenderDetail(),
  LenderList(),
  LenderFilterGranular(),
  TableOfContents(),
  AlphabetNav(),
  TableOfContentsEnhanced(),
  TextExpander(),
  LazyImage(),
  BlockFAQ(),
  BlockNewsletter(),
  BlockContact(),
  SingleLGLender()
]

components.map(component => component.init())
